import { render, staticRenderFns } from "./TenantConfirm.vue?vue&type=template&id=b7272712&scoped=true&"
import script from "./TenantConfirm.vue?vue&type=script&lang=js&"
export * from "./TenantConfirm.vue?vue&type=script&lang=js&"
import style0 from "./TenantConfirm.vue?vue&type=style&index=0&id=b7272712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7272712",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7272712')) {
      api.createRecord('b7272712', component.options)
    } else {
      api.reload('b7272712', component.options)
    }
    module.hot.accept("./TenantConfirm.vue?vue&type=template&id=b7272712&scoped=true&", function () {
      api.rerender('b7272712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ccd/TenantConfirm.vue"
export default component.exports